import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cn } from '../../lib/utils';
import { buttonVariants } from './button-variants';
function Button({ className, asChild = false, size, variant, ...props }) {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { className: cn(buttonVariants({ className, size, variant })), "data-slot": "button", ...props }));
}
export { Button };
